/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seating_Severity_SoftInputs */



/**
* | output |
* | --- |
* | "Minor seating issue" |
*
* @param {Seating_Severity_SoftInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const seating_severity_soft = /** @type {((inputs?: Seating_Severity_SoftInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seating_Severity_SoftInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Problème de placement mineur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema de asientos menor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Problema menor de alocação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema di disposizione minore")
	return /** @type {LocalizedString} */ ("Minor seating issue")
});